import { Flex } from "@radix-ui/themes";
import { FC } from "react";
import { Button, Modal } from "../../../../components";
import "./index.css";

type ImageModalProps = {
  img: string;
};

export const ImageModal: FC<ImageModalProps> = (props) => {
  const { img } = props;
  return (
    <Modal
      trigger={
        <img className="image-modal--preview-image" src={img} alt="Ablageort" />
      }
    >
      <Flex justify="center">
        <img
          className="image-modal--description-image"
          src={img}
          alt="Ablageort"
        />
      </Flex>
    </Modal>
  );
};
